import React from 'react';
const { Form } = require('react-redux-form');

import Headline from 'components/headline';
import { Header } from 'components/header/header';
import { RoadmapNavigation } from 'components/steps/RoadmapNavigation/RoadmapNavigation';
import classNames from 'classnames';
import './FullForm.scss';

class FullForm extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {
            children,
            title,
            subtitle,
            continueAction,
            formModel,
            onSubmit,
            onChange,
            cancelAction,
            icon,
            hideRoadMapNavigation,
            continueButtonEnabled,
            className,
            buttonContinueFakeDisabled,
            isButtonContinueLoading,
        } = this.props;

        return (
            <React.Fragment>
                <div className={classNames('prospects-content', className)}>
                    <Header />
                    <div className="prospects-step-content basic-layering" id="personalDataFrom">
                        <div className="prospects-step-content basic-layering">
                            <Headline
                                icon={icon || 'cliente'}
                                className="full-form-headline prospects-gutter prospects-initial"
                            >
                                <h2>{title}</h2>
                                {subtitle && <p>{subtitle}</p>}
                            </Headline>
                            <Form model={formModel} onSubmit={onSubmit} onChange={onChange}>
                                {children}
                                <div className="form__footer">
                                    {hideRoadMapNavigation === false && (
                                        <RoadmapNavigation
                                            buttonContinueFakeDisabled={buttonContinueFakeDisabled}
                                            buttonContinueAction={continueAction}
                                            buttonContinueType="submit"
                                            buttonContinueDisabled={!continueButtonEnabled}
                                            buttonPrevHidden={true}
                                            buttonCancelAction={cancelAction}
                                            isButtonContinueLoading={isButtonContinueLoading}
                                        />
                                    )}
                                </div>
                            </Form>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default FullForm;
